module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"empty":"У вас нет активных вакансий","publishedTill":"Опубликовано до: {date}"}}')
  delete Component.options._Ctor
}
